import {roles} from "@/Enums";

const readSettingsPolicy = [
  roles.Administrator,
  roles.Hauptbenutzer
];

const editSettingsPolicy = [
  roles.Administrator
];

export {
  readSettingsPolicy,
  editSettingsPolicy
}
